import { createSlice, createAsyncThunk, type PayloadAction } from "@reduxjs/toolkit";
import { fetchDashboardOverview, type UpcomingBirthday } from "../service/dashboardService";
import i18n from "@/i18n";

export const loadDashboardOverview = createAsyncThunk(
  "institutionDashboard/loadOverview",
  async ({ institutionId, academicYearId }: { institutionId: number; academicYearId?: number | null }) => {
    const data = await fetchDashboardOverview(institutionId, academicYearId);
    return data;
  }
);

interface DashboardState {
  statCards: any[];
  institution: any;
  subscription: any;
  inheritsSubscriptionFromOrg: boolean;
  feesOverview: any;
  feesSeries: { date: string; collected: number }[];
  feesByClass: { academicGroupId?: number; academicGroupName?: string; expected?: number; collected: number }[];
  studentsByClass: any[];
  recentActivities: any[];
  upcomingBirthdays: UpcomingBirthday[];
  dashboardTemplate: string;
  quickLinks: any[];
  loading: boolean;
  error: string | null;
}

const initialState: DashboardState = {
  statCards: [],
  institution: null,
  subscription: null,
  inheritsSubscriptionFromOrg: false,
  feesOverview: null,
  feesSeries: [],
  feesByClass: [],
  studentsByClass: [],
  recentActivities: [],
  upcomingBirthdays: [],
  dashboardTemplate: "CLASSIC",
  quickLinks: [],
  loading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: "institutionDashboard",
  initialState,
  reducers: {
    setDashboardTemplate(state, action: PayloadAction<string>) {
      state.dashboardTemplate = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadDashboardOverview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loadDashboardOverview.fulfilled, (state, action) => {
        state.loading = false;
        Object.assign(state, action.payload);
      })
      .addCase(loadDashboardOverview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? i18n.t("common:institutionAdmin.dashboard.failedToLoad");
      });
  },
});

export const { setDashboardTemplate } = dashboardSlice.actions;
export default dashboardSlice.reducer;